import * as React from 'react';
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

import { styled } from '@mui/material/styles';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';

import FormGroup from '@mui/material/FormGroup';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import Select from '@mui/material/Select';

import Rating from '@mui/material/Rating';
import Typography from '@mui/material/Typography';
import Switch from '@mui/material/Switch';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import CircularProgress from '@mui/material/CircularProgress';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import useMediaQuery from '@mui/material/useMediaQuery';

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';

import isEmail from 'validator/lib/isEmail';
import isStrongPassword from 'validator/lib/isStrongPassword';

import CheckIcon from '@mui/icons-material/Check';

import { Swiper } from 'swiper/react';
import { SwiperSlide } from 'swiper/react';
import { Pagination, Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import "./../assets/swiperCss.css";
import 'swiper/css/autoplay';

import PropTypes, { number } from 'prop-types';
import AppBar from '@mui/material/AppBar';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';

import Menu from '@mui/material/Menu';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import AdbIcon from '@mui/icons-material/Adb';

import { createTheme, responsiveFontSizes, ThemeProvider } from '@mui/material/styles';
import { themeResponsive } from "../../theme/responsiveTheme.js";

import AdminMenuComponent from "../../components/admin/AdminMenuComponent.js";
import CreateNewFolderTwoToneIcon from '@mui/icons-material/CreateNewFolderTwoTone';

// ---- Calendar
import dayjs, { Dayjs } from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import 'dayjs/locale/it';
import { TimeClock } from '@mui/x-date-pickers/TimeClock';

import { getGiornoDellAnno, getNumberOfDays, getIndexOfDaysDb, dayOfYear, getNumberOfWeek, getHoursAndMinutesStringFromMinutes } from '../../utils/dayUtils.js'
import { durationsMins } from './../../constants/durationsMins.ts';

import AppointmentCardComponent from "./AppointmentCardComponent.js";

const { strDateITAfromDayJs, strDateUSAfromDayJs, strDateITAfromStrUSA, strDateUSAfromStrITA } = require('../../utils/dateUtils.js')

const config = require("../../constants/constants.js")

const responsiveTheme = responsiveFontSizes(themeResponsive);

const widthPageSlide = 600;

const AppointmentPageComponent = ({ loginUserApiRequest, reduxDispatch, setReduxUserState }) => {
  const [validated, setValidated] = useState(false);
  const [loginUserResponseState, setLoginUserResponseState] = useState({
    success: "",
    error: "",
    loading: false,
  });

  const navigate = useNavigate();

  const config = require("../../constants/constants.js")

  const [name, setName] = useState("");
  const [note, setNote] = useState("");
  const [color, setColor] = useState("0000");
  const [count, setCount] = useState(0);
  const [price, setPrice] = useState(0);
  const [isBookable, setIsBookable] = useState(false);
  const [bookingPrice, setBookingPrice] = useState(0);
  const [category, setCategory] = useState("");
  const [event, setEvent] = useState("");
  const [images, setImages] = useState([]);
  const [pdfs, setPdfs] = useState([]);
  const [linkHttp, setLinkHttp] = useState("");

  const [eventTypesList, setEventTypesList] = useState([]);
  const [eventsList, setEventsList] = useState([]);

  const [isManyDays, setIsManyDays] = useState(false);

  const [displayPaperImages, setDisplayPaperImages] = useState("");

  const [bookingStartDate, setBookingStartDate] = React.useState(dayjs(new Date()));
  const [bookingStartDateNameOfWeek, setBookingStartDateNameOfWeek] = React.useState(dayjs(new Date()).format('dddd'));
  const [bookingEndDate, setBookingEndDate] = React.useState(dayjs(new Date()));
  const [bookingEndDateNameOfWeek, setBookingEndDateNameOfWeek] = React.useState(dayjs(new Date()).format('dddd'));

  const [hourStartBooking, setHourStartBooking] = React.useState(dayjs());
  const [hourStartBookingString, setHourStartBookingString] = useState("");
  const [indexStartDateBooking, setIndexStartDateBooking] = useState(0);
  const [hourEndBooking, setHourEndBooking] = React.useState(dayjs());
  const [hourEndBookingString, setHourEndBookingString] = useState("");
  const [indexEndDateBooking, setIndexEndDateBooking] = useState(0);

  const [categoriaScelta, setCategoriaScelta] = useState("");  // è la categoria cliccata nelTab "scegli la categoria"
  const [prodottoScelto, setProdottoScelto] = useState("");     // è il servizio/prodotto cliccata nelTab "scegli il servizio"

  const [titleAppointment, setTitleAppointment] = useState("");
  const [descriptionAppointment, setDescriptionAppointment] = useState("");
  const [noteAppointment, setNoteAppointment] = useState("");
  const [clienteDigitato, setClienteDigitato] = useState("");                     // è la ora cliccata nelTab
  const [risorsaScelta, setRisorsaScelta] = useState("");        // è la ora risorsa cliccata nelTab "scegli la risorsa"
  const [sitoScelto, setSitoScelto] = useState("");                 // è il sito cliccato nelTab "scegli il sito"
  const [clienteScelto, setClienteScelto] = useState("");           // è il cliente cliccato nelTab "scegli il cliente"
  const [durataScelta, setDurataScelta] = useState("0");                            // è la durata cliccata nelTab
  const [resources, setResources] = useState([]);
  const [sites, setSites] = useState([]);
  const [customersList, setCustomersList] = useState([]);
  
  const [sito, setSsito] = useState("");
  const [cliente, setCliente] = useState("");
  const [risorsa, setRisorsa] = useState("");

  const [page, setPage] = useState({});
  const [id, setId] = useState("");
  const [title, setTitle] = useState("");
  const [subTitle, setSubTitle] = useState("");
  const [description, setDescription] = useState("");
  const [customizedName, setCustomizedName] = useState("");
  const [customizedStreet, setCustomizedStreet] = useState("");
  const [customizedZip, setCustomizedZip] = useState("");
  const [customizedCity, setCustomizedCity] = useState("");
  const [customizedEmail, setCustomizedEmail] = useState("");
  const [customizedTelephone, setCustomizedTelephone] = useState("");
  const [tabAttivo, setTabAttivo] = React.useState('home');
  const [pathImage0, setPathImage0] = useState("");
  const [titleImage0, setTitleImage0] = useState("");
  const [subTitleImage0, setSubTitleImage0] = useState("");

  const address_marginLeft = "30px";

  const [showDateSection, setShowDateSection] = useState("");
  const [showHourAppointmentSection, setShowHourAppointmentSection] = useState("");
  const [showDailyEventsSection, setShowDailyEventsSection] = useState("");
  const [showInfoEventSection, setShowInfoEventSection] = useState("");
  const [showDetailAppointmentNumber, setShowDetailAppointmentNumber] = useState(-1);

  const [appointment, setAppointment] = useState({});
  const [appointments, setAppointments] = useState([{}]);
  const [dailyAppointments, setDailyAppointments] = useState([{}]);

  const getPageByMenuValueApiRequest = async (menuValue) => {
    console.log("[getPageByMenuValueApiRequest] leggo page con menuValue =", menuValue);
    const url = `/api/pages/menuValue/` + menuValue;
    const { data } = await axios.get(url);
    //console.log(`data =`, data);
    return data
  }

  useEffect(() => {
    getPageByMenuValueApiRequest('AGENDA').then((data) => {
      //console.log(`data 1 =`, data);
      setPage(data);
      setTitle(data?.title.text);
      setSubTitle(data?.subTitle.text);
      setDescription(data?.description.text);
      setTabAttivo('home');
      setId(data?._id);
      setCustomizedName(page?.customizedContent.name.text);
      setCustomizedStreet(page?.customizedContent.street.text);
      setCustomizedZip(page?.customizedContent.zip.text);
      setCustomizedCity(page?.customizedContent.city.text);
      setCustomizedEmail(page?.customizedContent.email.text);
      setCustomizedTelephone(page?.customizedContent.telephone.text);
      setPathImage0(data?.images[0].path);
      setTitleImage0(data?.imagesTitle[0].text);
      setSubTitleImage0(data?.imagesSubTitle[0].text);

      //setShowDailyEventsSection("Si");
      handleVediEventiGiorno();
      //console.log(`id =`, id);
      //console.log(`page?.images =`, page?.images);
      //console.log(`page?.title.text =`, page?.title.text);
      //console.log(`page?.description.text =`, page?.description.text);
      //console.log(`page?.customizedContent =`, page?.customizedContent);
      //console.log(`page?.customizedContent.name.text =`, page?.customizedContent.zip.text);
      //console.log(`images =`, data?.images);
      //console.log(`images =`, data?.images[0].path);
    })
      .catch((er) => {
        console.log(er);
      });
  }, [tabAttivo, id])


  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const [loginIcon, setLoginIcon] = React.useState(false);

  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const selectionEndDateFromCalendar = (event) => {
    console.log("date selected =" + event.format('YYYY-MM-DD'));
    console.log("name of day =" + event.format('dddd'));
    setBookingEndDate(dayjs(event.format('YYYY-MM-DD')));
    setBookingEndDateNameOfWeek(config.DAY_ITALIAN_NAMES[dayjs(event).day()]);
    //setIndexEndDateBooking(getIndexOfDaysDb(new Date(event.format('MM/DD/YYYY')), correctionIndexDay));
    //console.log("indexDate per DB = ", getIndexOfDaysDb(new Date(event.format('MM/DD/YYYY')), correctionIndexDay));
  }

  const handleSelectionStartHourFromCalendar = (event) => {
    console.log("hour selected =" + event);
    console.log("hour selected hh =" + event.format('HH:mm'));
    setHourStartBooking(event);
    setHourStartBookingString(event.format('HH:mm'));
    //const dayString = event.format('hh:mm');
  }

  const handleSelectionEndHourFromCalendar = (event) => {
    //console.log("hour selected =" + event);
    //console.log("hour selected hh =" + event.format('HH:mm'));
    setHourEndBooking(event);
    setHourEndBookingString(event.format('HH:mm'));
  }

  const handleVediEventiGiorno = (e) => {

        //setIndexStartDateBooking(getIndexOfDaysDb(dayjs(event.format('YYYY-MM-DD')))); 

    console.log("[handleVediEventiGiorno] bookingStartDate =" + bookingStartDate.format('YYYY-MM-DD'));
    setIndexEndDateBooking(getIndexOfDaysDb(dayjs(bookingStartDate.format('YYYY-MM-DD'))));
    
    console.log("[handleVediEventiGiorno] vedi eventi di indexStartDateBooking=", indexStartDateBooking);

    setAppointments(null);
    setDailyAppointments(null);

    // leggo db

    getAppointmentsByDayApiRequest(indexStartDateBooking)
      .then((data) => {
        setAppointments(data?.appointments);
        setDailyAppointments(data[0]?.appointments);
        //setAppointments(data?.appointments);
        console.log('[handleVediEventiGiorno] data=', data);
        console.log('[handleVediEventiGiorno] data?.appointments=', data[0]?.appointments);
        //console.log('appointment=', data?.appointment);
        //console.log('appointments=', data?.appointments);
        //setAppointment(data?.appointments[0]);
        //console.log('appointment=', data?.appointment);

      })
      .catch((er) => {
        console.log(er);
      });

/*      
    startDate = {
        hour: hourInMinutesStart,
        hourString: startHourString.hourMinutesString,
        indexDay: indexStartDateBooking,
        stringDay: strDateITAfromStrUSA(dayjs(bookingStartDate)),
        dayOfYear: getGiornoDellAnno(new Date(bookingStartDate)),
        weekOfYear: getNumberOfWeek(new Date(bookingStartDate)),
      }

      // endDateDaily da calcolare
      setHourEndBookingString(hourStartBookingString);
      setBookingEndDate(bookingStartDate);               // da calcolare
      setIndexEndDateBooking(indexStartDateBooking);

      let hourInMinutesEnd = Number(hourEndBookingString.substring(0, 2)) * 60 + Number(hourEndBookingString.substring(3, 5)) + durataScelta;
      //console.log("hourInMinutesEnd=", hourInMinutesEnd);
      //console.log("getHoursAndMinutesStringFromMinutes=", getHoursAndMinutesStringFromMinutes(hourInMinutesEnd));
      let endHourString = getHoursAndMinutesStringFromMinutes(hourInMinutesEnd);
      //console.log("startHourString=>", endHourString.hourMinutesString);

      endDate = {
        hour: hourInMinutesEnd,
        hourString: endHourString.hourMinutesString,
        indexDay: indexEndDateBooking,
        stringDay: strDateITAfromStrUSA(dayjs(bookingEndDate)),
        dayOfYear: getGiornoDellAnno(new Date(bookingEndDate)),
        weekOfYear: getNumberOfWeek(new Date(bookingEndDate)),
      }

      infoAppointment = {
        "indexDay": indexDay,
        "indexAppointment":  indexAppointment,

        "name": titleAppointment,
        "description": descriptionAppointment,
        "note": noteAppointment,
        "event": prodottoScelto,
        "eventtype": categoriaScelta,
        "start": startDate,
        "end": endDate,
        "durationMins": durataScelta,
        "resource": risorsaScelta,
        "site": sitoScelto,
        "customer": clienteDigitato,

      }  
  */  

      setShowDailyEventsSection("Si");


    /*
    const formInputs = {
      indexDay: indexStartDateBooking,
      stringDay: strDateITAfromStrUSA(dayjs(bookingStartDate)),
    };

    console.log("vedi eventi di formInputs=", formInputs);
    // eventi di {bookingStartDateNameOfWeek} {strDateITAfromStrUSA(dayjs(bookingStartDate))}

    getAppointmentsByDayApiRequest(formInputs)
      .then((data) => {
        setAppointment(data?.appointments[0]);
        console.log('appointments=', data);
        console.log('appointment=', data?.appointments[0]);
      })
      .catch((er) => {
        console.log(er);
      });
    */
  };

  const handleAnnullaFissaOraAppuntamento = (event) => {
    setShowHourAppointmentSection("No");
  }

  const handleAnnullaEventiDelGiorno = (event) => {
    setShowDailyEventsSection("No");
    setShowInfoEventSection("No");
  }

  const handleAnnullaInserisciInfo = (event) => {
    setShowInfoEventSection("No");
  }

  const handleAnnullaInCreaAppuntamento = (event) => {
    setShowDetailAppointmentNumber(-1);
  }

  const handleConfermaOraAppuntamento = (event) => {
    setShowInfoEventSection("Si");
  }

  const createAppointmentApiRequest = async (formInputs) => {

    console.log("[createAppointmentApiRequest]");
    console.log("[createAppointmentApiRequest] formInputs=", formInputs);

    const { data } = await axios.post(`/api/appointments`, { ...formInputs });
    
    return data;
  };

  const getAppointmentsByDayApiRequest = async (indexDay) => {
    console.log("[getAppointmentsByDayApiRequest]");
    console.log("[getAppointmentsByDayApiRequest] indexDay=", indexDay);
    const { data } = await axios.get(`/api/appointments/indexDay/${indexDay}`);
    return data;
  };

  const updateAppointmentApiRequest = async (indexDay, indexAppointment) => {
  
    console.log("[updateAppointmentApiRequest] indexDay=", indexDay)
    console.log("[updateAppointmentApiRequest] indexAppointment=", indexAppointment)

    let infoAppointment = {}
    let startDate = {}
    let endDate = {}

    //console.log(">>" + hourStartBookingString.substring(0, 2));
    //console.log(">>" + hourStartBookingString.substring(3, 5));

    let hourInMinutesStart = Number(hourStartBookingString.substring(0, 2)) * 60 + Number(hourStartBookingString.substring(3, 5));
    //console.log("hourInMinutesStart=", hourInMinutesStart);
    //console.log("getHoursAndMinutesStringFromMinutes=", getHoursAndMinutesStringFromMinutes(hourInMinutesStart));
    let startHourString = getHoursAndMinutesStringFromMinutes(hourInMinutesStart);
    //console.log("startHourString=>", startHourString.hourMinutesString);

    console.log("[handleSalvaAppuntamento] durataScelta=", durataScelta);
    if (durataScelta === "0") {
      console.log("[handleSalvaAppuntamento] devi indicare una durata");
      //Alert("devi indicare una durata");
      alert("devi indicare una durata");
      /*
      <Alert icon={<CheckIcon fontSize="inherit" />} severity="warning">
        devi indicare una durata
      </Alert>      
      */
    } else {

      startDate = {
        hour: hourInMinutesStart,
        hourString: startHourString.hourMinutesString,
        indexDay: indexStartDateBooking,
        stringDay: strDateITAfromStrUSA(dayjs(bookingStartDate)),
        dayOfYear: getGiornoDellAnno(new Date(bookingStartDate)),
        weekOfYear: getNumberOfWeek(new Date(bookingStartDate)),
      }

      // endDateDaily da calcolare
      setHourEndBookingString(hourStartBookingString);
      setBookingEndDate(bookingStartDate);               // da calcolare
      setIndexEndDateBooking(indexStartDateBooking);

      let hourInMinutesEnd = Number(hourEndBookingString.substring(0, 2)) * 60 + Number(hourEndBookingString.substring(3, 5)) + durataScelta;
      //console.log("hourInMinutesEnd=", hourInMinutesEnd);
      //console.log("getHoursAndMinutesStringFromMinutes=", getHoursAndMinutesStringFromMinutes(hourInMinutesEnd));
      let endHourString = getHoursAndMinutesStringFromMinutes(hourInMinutesEnd);
      //console.log("startHourString=>", endHourString.hourMinutesString);

      endDate = {
        hour: hourInMinutesEnd,
        hourString: endHourString.hourMinutesString,
        indexDay: indexEndDateBooking,
        stringDay: strDateITAfromStrUSA(dayjs(bookingEndDate)),
        dayOfYear: getGiornoDellAnno(new Date(bookingEndDate)),
        weekOfYear: getNumberOfWeek(new Date(bookingEndDate)),
      }

      infoAppointment = {
        "indexDay": indexDay,
        "indexAppointment":  indexAppointment,

        "name": titleAppointment,
        "description": descriptionAppointment,
        "note": noteAppointment,
        "event": prodottoScelto,
        "eventtype": categoriaScelta,
        "start": startDate,
        "end": endDate,
        "durationMins": durataScelta,
        "resource": risorsaScelta,
        "site": sitoScelto,
        "customer": clienteDigitato,

      }  
    }

    console.log("[updateAppointmentApiRequest] infoAppointment=", infoAppointment)
    console.log("[updateAppointmentApiRequest] POST /api/appointments/update?indexDay")

    const { data } = await axios.post("/api/appointments/update", infoAppointment);
    return data;
  };

  const handleSalvaAppuntamento = (event) => {
    // memorizzo l'appuntamento/evento


    console.log("[handleSalvaAppuntamento] vedi eventi di indexStartDateBooking=", indexStartDateBooking);
    console.log("[handleSalvaAppuntamento] bookingStartDate =" + bookingStartDate.format('YYYY-MM-DD'));

    //event.preventDefault();
    //event.stopPropagation();

    let infoAppointment = {}
    let startDate = {}
    let endDate = {}

    //console.log(">>" + hourStartBookingString.substring(0, 2));
    //console.log(">>" + hourStartBookingString.substring(3, 5));

    let hourInMinutesStart = Number(hourStartBookingString.substring(0, 2)) * 60 + Number(hourStartBookingString.substring(3, 5));
    //console.log("hourInMinutesStart=", hourInMinutesStart);
    //console.log("getHoursAndMinutesStringFromMinutes=", getHoursAndMinutesStringFromMinutes(hourInMinutesStart));
    let startHourString = getHoursAndMinutesStringFromMinutes(hourInMinutesStart);
    //console.log("startHourString=>", startHourString.hourMinutesString);

    console.log("[handleSalvaAppuntamento] durataScelta=", durataScelta);
    if (durataScelta === "0") {
      console.log("[handleSalvaAppuntamento] devi indicare una durata");
      //Alert("devi indicare una durata");
      alert("devi indicare una durata");
      /*
      <Alert icon={<CheckIcon fontSize="inherit" />} severity="warning">
        devi indicare una durata
      </Alert>      
      */
    } else {

      startDate = {
        hour: hourInMinutesStart,
        hourString: startHourString.hourMinutesString,
        indexDay: indexStartDateBooking,
        stringDay: strDateITAfromStrUSA(dayjs(bookingStartDate)),
        dayOfYear: getGiornoDellAnno(new Date(bookingStartDate)),
        weekOfYear: getNumberOfWeek(new Date(bookingStartDate)),
      }

      // endDateDaily da calcolare
      setHourEndBookingString(hourStartBookingString);
      setBookingEndDate(bookingStartDate);               // da calcolare
      setIndexEndDateBooking(indexStartDateBooking);

      let hourInMinutesEnd = Number(hourEndBookingString.substring(0, 2)) * 60 + Number(hourEndBookingString.substring(3, 5)) + durataScelta;
      //console.log("hourInMinutesEnd=", hourInMinutesEnd);
      //console.log("getHoursAndMinutesStringFromMinutes=", getHoursAndMinutesStringFromMinutes(hourInMinutesEnd));
      let endHourString = getHoursAndMinutesStringFromMinutes(hourInMinutesEnd);
      //console.log("startHourString=>", endHourString.hourMinutesString);

      endDate = {
        hour: hourInMinutesEnd,
        hourString: endHourString.hourMinutesString,
        indexDay: indexEndDateBooking,
        stringDay: strDateITAfromStrUSA(dayjs(bookingEndDate)),
        dayOfYear: getGiornoDellAnno(new Date(bookingEndDate)),
        weekOfYear: getNumberOfWeek(new Date(bookingEndDate)),
      }

      infoAppointment =
      {
        "name": titleAppointment,
        "description": descriptionAppointment,
        "note": noteAppointment,
        "event": prodottoScelto,
        "eventtype": categoriaScelta,
        "resource": risorsaScelta,
        "site": sitoScelto,
        "durationMins": durataScelta,
        "customer": clienteDigitato,
        "start": startDate,
        "end": endDate,
      };

      const formInputs = {
        indexDay: indexStartDateBooking,
        stringDay: strDateITAfromStrUSA(dayjs(bookingStartDate)),
        dayOfYear: getGiornoDellAnno(new Date(bookingStartDate)),
        weekOfYear: getNumberOfWeek(new Date(bookingStartDate)),
        numAppointments: 1,
        appointments: infoAppointment,
      };

      console.log('[handleSalva] showDetailAppointmentNumber=', showDetailAppointmentNumber)
      console.log('[handleSalva] formInputs=', formInputs)

      if ( showDetailAppointmentNumber === -1) {
        createAppointmentApiRequest(formInputs)
          .then((data) => {

          })
          .catch((er) => {
            console.log(er);
          });

        alert("Appuntamento salvato showDetailAppointmentNumber = "+showDetailAppointmentNumber);
      } else {

        updateAppointmentApiRequest(indexStartDateBooking, showDetailAppointmentNumber)
          .then((data) => {

          })
          .catch((er) => {
            console.log(er);
          });

        alert("Appuntamento modificato showDetailAppointmentNumber = "+showDetailAppointmentNumber);
    }

      //setShowHourAppointmentSection("No");
      //setShowDetailAppointmentNumber(-1);
      setShowInfoEventSection("No");
      setShowHourAppointmentSection("No");
      console.log("[handleSalvaAppuntamento] showHourAppointmentSection=", showHourAppointmentSection)

    }

  };

  const getEventsApiRequest = async (categoryName, pageNumParam = null, searchQuery = "", filters = {}, sortOption = "") => {
    console.log('categoryName=', categoryName)
    //console.log('categoriaScelta=',category)  
    const search = searchQuery ? `search/${searchQuery}/` : "";
    const category = categoryName ? `category/${categoryName}/` : "";
    const url = `/api/events/event/${categoryName}`;
    const { data } = await axios.get(url);
    return data
  }

  const handleSelectEventType = (event) => {
    setCategory(event.target.value);
    setCategoriaScelta(event.target.value);

    getEventsApiRequest(event.target.value, "", "", "", "")
      .then((productItems) => {
        setEventsList(productItems.events);
        console.log('combo =', event.target.value);
        //console.log('categoriaScelta=',categoriaScelta); 
        console.log('productItems=', productItems);
      })
      .catch((er) => {
        console.log(er);
      });
  };

  const handleSelectEvent = (event) => {
    setEvent(event.target.value);
    setProdottoScelto(event.target.value);
  };

  const handleChangeDurata = (event) => {
    setDurataScelta(event.target.value);
    console.log('[handleChangeDurata} event.target.value=', event.target.value);
  };

  const getCategories = async (abctrl) => {
    const { data } = await axios.get("/api/eventtypes", {
      signal: abctrl.signal,
    });
    return data
  }

  const getResourcesApiRequest = async () => {
    const url = `/api/resources`;
    const { data } = await axios.get(url);
    return data
  }

  const getSitesApiRequest = async () => {
    const url = `/api/sites`;
    const { data } = await axios.get(url);
    return data
  }

  const getCustomersApiRequest = async () => {
    const url = `/api/customers`;
    const { data } = await axios.get(url);
    return data;
  }

  useEffect(() => {
    const abctrl = new AbortController();
    getCategories(abctrl)
      .then((res) => setEventTypesList(res))
      .catch((er) =>
        console.log("error")
      );
    return () => abctrl.abort();
  }, [setEventTypesList]);

  useEffect(() => {
    let oggi = dayjs(new Date());
    console.log("oggi = ", dayjs(new Date()));
    setBookingStartDateNameOfWeek(config.DAY_ITALIAN_NAMES[oggi.day()]);
    console.log("bookingStartDateNameOfWeek = ", config.DAY_ITALIAN_NAMES[oggi.day()]);
    
    setBookingStartDate(dayjs(oggi.format('YYYY-MM-DD')));
    console.log("bookingStartDate = ", dayjs(oggi.format('YYYY-MM-DD')));
    setBookingEndDate(dayjs(oggi.format('YYYY-MM-DD')));

    setIndexStartDateBooking(getIndexOfDaysDb(dayjs(oggi.format('YYYY-MM-DD'))));
    console.log("indexStartDateBooking = ", getIndexOfDaysDb(dayjs(oggi.format('YYYY-MM-DD'))));
    setIndexEndDateBooking(getIndexOfDaysDb(dayjs(oggi.format('YYYY-MM-DD'))));

    //setBookingStartDate(dayjs(event.format('YYYY-MM-DD')));
    //setBookingStartDateNameOfWeek(config.DAY_ITALIAN_NAMES[dayjs(event).day()]);
    //setBookingStartDate(dayjs('2026-03-01'));
    //setIndexStartDateBooking(getIndexOfDaysDb(dayjs('2026-03-01'), 0));
    //setBookingStartDateNameOfWeek(config.DAY_ITALIAN_NAMES[dayjs('2026-03-01').day()]);

    setDisplayPaperImages("none")
  }, [setBookingStartDate])

  useEffect(() => {
    getResourcesApiRequest().then((res) => setResources(res))
      .catch((er) => {
        console.log(er);
      });
  }, []);

  useEffect(() => {
    getSitesApiRequest().then((sit) => setSites(sit))
      .catch((er) => {
        console.log(er);
      });
  }, []);

  useEffect(() => {
    getCustomersApiRequest().then((cus) => {
      setCustomersList(cus);
      console.log('customersList data =', cus)
      console.log(`[useEffect] customersList = `, customersList);
    })
      .catch((er) => {
        console.log(er);
      });
  }, []);


  const handleChangeSito = (event) => {
    setSitoScelto(event.target.value);
  };

  const handleChangeRisorsa = (event) => {
    setRisorsaScelta(event.target.value);
  };

  const handleChangeCliente = (event) => {
    setClienteDigitato(event.target.value);
  };

  function getFieldsCustomer(input, field1, field2, field3) {
    var output = [];
    for (var i = 0; i < input.length; ++i)
      output.push(input[i][field1] + ' ' + input[i][field2] + ' ' + input[i][field3]);
    return output;
  }
  var optionCustomers = getFieldsCustomer(customersList, 'title', 'name', 'surname');

  const switchIsManyDays = (event) => {
    setIsManyDays(event.target.checked);
    console.log('[switch] isManyDays =', isManyDays)
  };

  return (
    <>

      <Box sx={{ flexGrow: 1 }}>

        <AdminMenuComponent></AdminMenuComponent>

        <Grid container spacing={{ xs: 0, md: 2 }}>

          {/* 
            <Grid
              size={{ xs: 12, md: 12 }}
              padding={{ xs: 0, md: 0 }}
            >

              <Box sx={{ width: { md: { widthPageSlide } } }}>

                <Swiper
                  style={{
                    '--swiper-navigation-color': '#fff',
                    // isScrollpage
                    //
                    // isA4page
                    height: useMediaQuery('(min-width:600px)') ? "500px" : "300px",
                  }}

                  loop={true}
                  autoplay={{
                    delay: 2500,
                    disableOnInteraction: false
                  }}

                  lazy={true}
                  pagination={{
                    clickable: true,
                  }}
                  navigation={true}
                  modules={[Pagination, Navigation, Autoplay]}
                  className="image-dim"
                >

                  <SwiperSlide>
                    <img
                      src={pathImage0}
                      loading="lazy"
                    />
                    <div class="text-overlay">
                      <p>
                        <Typography variant="h6" color='#ffffff'
                          sx={{
                            paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1,
                            p: 0, m: 0,
                          }}
                        >
                          {titleImage0}
                        </Typography>
                      </p>
                      <p>
                        <Typography variant="h7" color='#dfdfde'
                          sx={{
                            paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 1,
                            p: 0, m: 0,
                          }}
                        >
                          {subTitleImage0}
                        </Typography>
                      </p>
                    </div>
                    <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                  </SwiperSlide>

                  {page.images?.map((itemImg, id) => (

                    (id > 0 &&

                      <SwiperSlide>
                        <img
                          src={itemImg.path}
                          loading="lazy"
                        />
                        <div class="text-overlay">
                          <p>
                            <Typography variant="h6" color='#ffffff'
                              sx={{
                                paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1,
                                p: 0, m: 0,
                              }}
                            >
                              {itemImg.title}
                            </Typography>
                          </p>
                          <p>
                            <Typography variant="h7" color='#dfdfde'
                              sx={{
                                paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 1,
                                p: 0, m: 0,
                              }}
                            >
                              {itemImg.subTitle}
                            </Typography>
                          </p>
                        </div>
                        <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                      </SwiperSlide>

                    )
                  ))}

                </Swiper>

              </Box>

            </Grid>

            */}

          <Grid
            size={{ xs: 12, md: 10 }}
            paddingTop={{ xs: 0, md: 1 }}
            paddingLeft={1}
            paddingRight={3}
            spacing={0}
          >
            <Stack
              spacing={2}
              sx={{ flexDirection: { xs: "column", md: "column" }, paddingTop: { xs: 0, md: 0 }, paddingLeft: 1, paddingRight: 0, }}
            >

              <Typography
                sx={{
                  paddingTop: { xs: 2, md: 0 }, paddingBottom: 0, paddingLeft: { xs: 1, md: 0 }, paddingRight: 0,
                  fontFamily: 'Arial',
                  fontWeight: 500,
                  fontSize: 30,
                  color: 'navy',
                }}
              >
                <b>{title}</b>
              </Typography>

              <Typography
                sx={{
                  paddingTop: 0, paddingBottom: 0, paddingLeft: 2, paddingRight: 0,
                  fontFamily: 'Arial',
                  fontWeight: 300,
                  fontSize: 20,
                  color: 'navy',
                }}
              >
                <em>{subTitle}</em>
              </Typography>

              <Typography
                sx={{
                  paddingTop: 0, paddingBottom: 0, paddingLeft: 2, paddingRight: 0,
                  fontFamily: 'Arial',
                  fontWeight: 100,
                  fontSize: 14,
                  color: 'black',
                }}
              >
                {description}
              </Typography>

            </Stack>

            <Box
              sx={{
                paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                height: 30
              }}
            />

            <Grid container
              spacing={2}
              sx={{
                paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
              }}
            >

              <Grid size={{ xs: 1, md: 0.1 }}>
              </Grid>

              <Grid size={{ xs: 12, md: 3.4 }}
                sx={{
                  paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                }}
              >

                <Paper
                  sx={{
                    paddingTop: 1, paddingBottom: 2, paddingLeft: 1, paddingRight: 1,
                    background: '#cce0e6',
                    color: '#3b1e8d'
                  }}
                  elevation={6}
                >

                  <Typography
                    sx={{
                      paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                      fontFamily: 'Arial',
                      fontWeight: 600,
                      fontSize: 20,
                      color: 'navy',
                      background: '#44cdc4',
                      textAlign: 'center',
                    }}
                  >
                    {bookingStartDateNameOfWeek} {strDateITAfromStrUSA(dayjs(bookingStartDate))}
                  </Typography>


                  <LocalizationProvider
                    dateAdapter={AdapterDayjs}
                    adapterLocale="it"
                  >
                    <DemoContainer components={['DateCalendar', 'DateCalendar']} color={'#3b1e8d'}>
                      <DemoItem color={'#3b1e8d'}>

                        <DateCalendar
                          value={bookingStartDate}

                          onChange={(newValue) => {
                              // nascondo crea evento 
                              setShowDetailAppointmentNumber(-1);
                              setShowHourAppointmentSection("No");
                              // nascondo dettagli evento 
                              setShowInfoEventSection("No");

                              setBookingStartDate(newValue);
                              setBookingStartDateNameOfWeek(config.DAY_ITALIAN_NAMES[dayjs(newValue).day()]);
                              console.log('Date selected:', newValue);
                              console.log('Date selected:', newValue.format('YYYY-MM-DD'));
                              console.log('Date selected:', config.DAY_ITALIAN_NAMES[dayjs(newValue).day()]);

                              setIndexStartDateBooking(getIndexOfDaysDb(dayjs(newValue.format('YYYY-MM-DD')))); 
                              
                              console.log("indexStartDateBooking = ", getIndexOfDaysDb(dayjs(newValue.format('YYYY-MM-DD'))));
                              //setIndexEndDateBooking(getIndexOfDaysDb(dayjs(event.format('YYYY-MM-DD')), correctionIndexDay));
                            
                              setAppointments(null);
                              setDailyAppointments(null);

                              // leggo db

                              getAppointmentsByDayApiRequest(getIndexOfDaysDb(dayjs(newValue.format('YYYY-MM-DD'))))
                                .then((data) => {
                                  setAppointments(data?.appointments);
                                  setDailyAppointments(data[0]?.appointments);
                                  //setAppointments(data?.appointments);
                                  console.log('[handleVediEventiGiorno] data=', data);
                                  console.log('[handleVediEventiGiorno] data?.appointments=', data[0]?.appointments);
                                  //console.log('appointment=', data?.appointment);
                                  //console.log('appointments=', data?.appointments);
                                  //setAppointment(data?.appointments[0]);
                                  //console.log('appointment=', data?.appointment);

                                })
                              .catch((er) => {
                                console.log(er);
                              });

                              setShowDailyEventsSection("Si");
                            }}

                          sx={{
                            bgcolor: '#a9d1f7',
                            boxShadow: 1,
                            borderRadius: 2,
                            //p: 2,
                            minWidth: 300,
                          }}
                          minDate={dayjs('2026-01-01')}
                          maxDate={dayjs('2028-12-31')}
                        />
                      </DemoItem>
                    </DemoContainer>
                  </LocalizationProvider>

                      {/* 
                  <Box
                    sx={{ '& > :not(style)': { m: 1, } }}
                  >

                    <Stack
                      direction="row"
                      justifyContent="flex-start"
                      alignItems="center"
                      spacing={1}
                      my={0}
                    >

                      <Button
                        type="button"
                        variant="contained"
                        //color="success"
                        //size="small"
                        onClick={(e) => {
                          setShowDailyEventsSection("No");
                          setShowDetailAppointmentNumber(-1);
                          setShowHourAppointmentSection("Si");
                          //handleVediEventiGiorno();
                        }}
                        sx={{
                          width: "20ch",
                          borderRadius: 2,
                          //backgroundColor: "#148840",
                        }}
                      >
                        <Stack
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          spacing={0}
                          my={0}
                        >
                          <Typography
                            sx={{
                              paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                              color: 'white',
                              fontFamily: 'Roboto',
                              textTransform: 'none',
                              fontSize: 16,
                            }}
                          >
                            <CreateNewFolderTwoToneIcon
                              fontSize="inherit"
                            >
                            </CreateNewFolderTwoToneIcon>
                            &nbsp;Crea evento&nbsp;
                          </Typography>
                        </Stack>
                      </Button>

                      <Button
                        type="button"
                        variant="contained"
                        //color="success"
                        //size="small"
                        onClick={(e) => {
                          handleVediEventiGiorno();
                        }}
                        sx={{
                          width: "20ch",
                          borderRadius: 2,
                          //backgroundColor: "#148840",
                        }}
                      >
                        <Stack
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          spacing={0}
                          my={0}
                        >
                          <Typography
                            sx={{
                              paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                              color: 'white',
                              fontFamily: 'Roboto',
                              textTransform: 'none',
                              fontSize: 16,
                            }}
                          >
                            <CreateNewFolderTwoToneIcon
                              fontSize="inherit"
                            >
                            </CreateNewFolderTwoToneIcon>
                            &nbsp;Vedi giorno &nbsp;
                          </Typography>
                        </Stack>

                      </Button>

                    </Stack>

                  </Box>
                      */}

                </Paper>

                <Box
                  sx={{
                    paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                    height: 40
                  }}
                />

              </Grid>

              <Grid size={{ xs: 1, md: 0.1 }}>
              </Grid>

              {/* ---------------------------   INI inserimento ora inizio   --------------------------- */}

              <Grid size={{ xs: 12, md: 3.4 }}
                display={showHourAppointmentSection === 'Si' ? "block" : "none"}
                sx={{
                  paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                }}
              >

                <Paper
                  sx={{
                    paddingTop: 1, paddingBottom: 2, paddingLeft: 1, paddingRight: 1,
                    background: '#cce0e6',
                    color: 'navy',

                  }}
                  elevation={6}
                >

                  <Typography
                    sx={{
                      paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                      fontFamily: 'Roboto',
                      fontWeight: 300,
                      fontSize: 20,
                      color: 'yellow',
                      background: '#3970c9',
                      textAlign: 'center',
                    }}
                  >
                    crea evento {bookingStartDateNameOfWeek} {strDateITAfromStrUSA(dayjs(bookingStartDate))}
                  </Typography>

                  <Box display="flex" flexDirection="row">
                    <Typography
                      sx={{
                        paddingTop: 2, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                        fontFamily: 'Arial',
                        fontWeight: 600,
                        fontSize: 16,
                        color: 'navy',
                        textAlign: 'left'
                      }}
                    >
                      &nbsp;ora di inizio evento
                    </Typography>
                    <Typography
                      sx={{
                        paddingTop: 1.3, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                        fontFamily: 'Rpboto',
                        fontWeight: 600,
                        fontSize: 22,
                        color: 'black',
                        //background: 'green',
                        textAlign: 'center'
                      }}
                    >
                      &nbsp;&nbsp;{hourStartBookingString}
                    </Typography>
                  </Box>

                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={['TimeClock', 'TimeClock']} color={'#3b1e8d'}>
                      <DemoItem label="">
                        <TimeClock
                          value={hourStartBooking}
                          sx={{
                            bgcolor: '#a9d1f7',
                            boxShadow: 1,
                            borderRadius: 2,
                            //p: 2,
                            //minWidth: 300,
                          }}
                          //onChange={(newValue) => setHourMinuteValue(newValue)}
                          onChange={
                            handleSelectionStartHourFromCalendar
                          }
                          ampm={false} />
                      </DemoItem>
                    </DemoContainer>
                  </LocalizationProvider>

                  <FormControlLabel
                    control={<Switch defaultChecked />}
                    checked={isManyDays}
                    onChange={switchIsManyDays}
                    label="più giorni"
                    sx={{
                      paddingTop: 1, paddingLeft: 1, paddingRight: 0,
                    }}
                  />


                  {isManyDays &&

                    <Stack
                      sx={{
                        flexDirection: { xs: "row", md: "row" },
                        paddingTop: 0, paddingLeft: 0, paddingRight: 0,
                      }}
                    >

                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['TimeClock', 'TimeClock']} color={'#3b1e8d'}>

                          <Box display="flex" flexDirection="row">
                            <Typography
                              sx={{
                                paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                                fontFamily: 'Arial',
                                fontWeight: 600,
                                fontSize: 16,
                                color: 'navy',
                                textAlign: 'left'
                              }}
                            >
                              &nbsp;giorno fine evento
                            </Typography>
                            <Typography
                              sx={{
                                paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                                fontFamily: 'Arial',
                                fontWeight: 600,
                                fontSize: 16,
                                color: 'navy',
                                textAlign: 'left'
                              }}
                            >
                              &nbsp;{bookingEndDateNameOfWeek} {strDateITAfromStrUSA(dayjs(bookingEndDate))}
                            </Typography>
                          </Box>

                          <LocalizationProvider
                            dateAdapter={AdapterDayjs}
                            adapterLocale="it"
                          >
                            <DemoContainer components={['DateCalendar', 'DateCalendar']} color={'#3b1e8d'}>
                              <DemoItem label="" color={'#3b1e8d'}>
                                <DateCalendar
                                  value={bookingEndDate}
                                  onChange={selectionEndDateFromCalendar}
                                  sx={{
                                    bgcolor: '#a9d1f7',
                                    boxShadow: 1,
                                    borderRadius: 2,
                                    //p: 2,
                                    minWidth: 300,
                                  }}
                                  minDate={dayjs('2026-01-01')}
                                  maxDate={dayjs('2028-12-31')}
                                />
                              </DemoItem>
                            </DemoContainer>
                          </LocalizationProvider>

                          <Box display="flex" flexDirection="row">
                            <Typography
                              sx={{
                                paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                                fontFamily: 'Arial',
                                fontWeight: 600,
                                fontSize: 16,
                                color: 'navy',
                                textAlign: 'center'
                              }}
                            >
                              &nbsp;ora di fine evento
                            </Typography>
                            <Typography
                              sx={{
                                paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                                fontFamily: 'Rpboto',
                                fontWeight: 600,
                                fontSize: 22,
                                color: 'black',
                                //background: 'green',
                                textAlign: 'center'
                              }}
                            >
                              &nbsp;{hourEndBookingString}
                            </Typography>
                          </Box>

                          <DemoItem label="">
                            <TimeClock
                              value={hourEndBooking}
                              sx={{
                                bgcolor: '#a9d1f7',
                                boxShadow: 1,
                                borderRadius: 2,
                                //p: 2,
                                //minWidth: 300,
                              }}
                              //onChange={(newValue) => setHourMinuteValue(newValue)}
                              onChange={handleSelectionEndHourFromCalendar}
                              ampm={false} />
                          </DemoItem>

                        </DemoContainer>
                      </LocalizationProvider>

                    </Stack>
                  }

                  <Box
                    sx={{ '& > :not(style)': { m: 1, } }}
                  >

                    <Stack
                      direction="row"
                      justifyContent="flex-start"
                      alignItems="center"
                      spacing={1}
                      my={0}
                    >

                      <Button
                        type="button"
                        variant="contained"
                        color="warning"
                        //size="small"
                        onClick={(e) => {
                          //handleAnnullaFissaOraAppuntamento();
                          setShowHourAppointmentSection("No");
                          setShowInfoEventSection("No");
                        }}
                        sx={{
                          width: "20ch",
                          borderRadius: 2,
                          //backgroundColor: "#148840",
                        }}
                      >
                        <Stack
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          spacing={0}
                          my={0}
                        >
                          <Typography
                            sx={{
                              paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                              color: 'white',
                              fontFamily: 'Roboto',
                              textTransform: 'none',
                              fontSize: 16,
                            }}
                          >
                            <CreateNewFolderTwoToneIcon
                              fontSize="inherit"
                            >
                            </CreateNewFolderTwoToneIcon>
                            &nbsp;Chiudi&nbsp;
                          </Typography>
                        </Stack>
                      </Button>

                      {/* 
                      <Button
                        type="button"
                        variant="contained"
                        color="success"
                        //size="small"
                        onClick={(e) => {
                          handleConfermaOraAppuntamento();
                        }}
                        sx={{
                          width: "20ch",
                          borderRadius: 2,
                          backgroundColor: "#148840",
                        }}
                      >
                        <Stack
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          spacing={0}
                          my={0}
                        >
                          <Typography
                            sx={{
                              paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                              color: 'white',
                              fontFamily: 'Roboto',
                              textTransform: 'none',
                              fontSize: 16,
                            }}
                          >
                            <CreateNewFolderTwoToneIcon
                              fontSize="inherit"
                            >
                            </CreateNewFolderTwoToneIcon>
                            &nbsp;Conferma&nbsp;
                          </Typography>
                        </Stack>
                      </Button>
                      */}


                    </Stack>

                  </Box>

                </Paper>

              </Grid>

              {/* ---------------------------   FIN inserimento ora inizio   --------------------------- */}


              {/* -----------------   INI visualizza tutti gli eventi del giorno  ----------------- */}

              <Grid size={{ xs: 12, md: 4.5 }}
                display={showDailyEventsSection === 'Si' ? "block" : "none"}
                sx={{
                  paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                }}
              >

                <Paper
                  sx={{
                    paddingTop: 1, paddingBottom: 2, paddingLeft: 1, paddingRight: 1,
                    background: '#cce0e6',
                    color: 'navy',

                  }}
                  elevation={6}
                >

                  <Typography
                    sx={{
                      paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                      fontFamily: 'Roboto',
                      fontWeight: 300,
                      fontSize: 20,
                      color: 'yellow',
                      background: '#3970c9',
                      textAlign: 'center',
                    }}
                  >
                    &nbsp;eventi di {bookingStartDateNameOfWeek} {strDateITAfromStrUSA(dayjs(bookingStartDate))} show={showDetailAppointmentNumber}
                  </Typography>

                  <Box display="flex" flexDirection="row">

                    <Grid
                      container
                      size={{ xs: 12, md: 4 }}
                      paddingTop={{ xs: 1, md: 2 }}
                      paddingLeft={{ xs: 1, md: 1 }}
                      paddingRight={{ xs: 1, md: 1 }}
                      spacing={{ xs: 2, md: 1 }}
                    >

                      {dailyAppointments &&

                        dailyAppointments.map((appointment, idx) => (

                          <AppointmentCardComponent appointmentItem={appointment} idx={idx} setShowDetailAppointmentNumber={setShowDetailAppointmentNumber} setShowInfoEventSection={setShowInfoEventSection} dailyAppointments={dailyAppointments}
                            setHourStartBooking={setHourStartBooking} setHourStartBookingString={setHourStartBookingString} setDurataScelta={setDurataScelta} setCategory={setCategory} setEvent={setEvent} setProdottoScelto={setProdottoScelto} setTitleAppointment={setTitleAppointment} 
                            setDescriptionAppointment={setDescriptionAppointment} setNoteAppointment={setNoteAppointment} setClienteDigitato={setClienteDigitato} setRisorsaScelta={setRisorsaScelta} setSitoScelto={setSitoScelto}                         
                            getEventsApiRequest={getEventsApiRequest} setEventsList={setEventsList}
                          />
                         
                          )
                        )
                      }

                      <Box
                        sx={{
                          paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                          height: 10
                        }}
                      />

                    </Grid>

                    <Typography
                      sx={{
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                        fontFamily: 'Arial',
                        fontWeight: 600,
                        fontSize: 16,
                        color: 'black',
                        textAlign: 'left'
                      }}
                    >
                      &nbsp;{hourStartBookingString}
                    </Typography>
                  </Box>

                  <Box
                    sx={{ '& > :not(style)': { m: 1, } }}
                  >

                    <Stack
                      direction="row"
                      justifyContent="flex-start"
                      alignItems="center"
                      spacing={1}
                      my={0}
                    >

                      <Button
                        type="button"
                        variant="contained"
                        color="warning"
                        //size="small"
                        onClick={(e) => {
                          handleAnnullaEventiDelGiorno();
                        }}
                        sx={{
                          width: "20ch",
                          borderRadius: 2,
                          //backgroundColor: "#148840",
                        }}
                      >
                        <Stack
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          spacing={0}
                          my={0}
                        >
                          <Typography
                            sx={{
                              paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                              color: 'white',
                              fontFamily: 'Roboto',
                              textTransform: 'none',
                              fontSize: 16,
                            }}
                          >
                            <CreateNewFolderTwoToneIcon
                              fontSize="inherit"
                            >
                            </CreateNewFolderTwoToneIcon>
                            &nbsp;Chiudi&nbsp;
                          </Typography>
                        </Stack>
                      </Button>

                      <Button
                        type="button"
                        variant="contained"
                        color="success"
                        //size="small"
                        onClick={(e) => {                        
                          setShowInfoEventSection("Si");

                          setShowDailyEventsSection("No");
                          setShowDetailAppointmentNumber(-1);
                          setShowHourAppointmentSection("Si");
                        }}

                        sx={{
                          width: "20ch",
                          borderRadius: 2,
                          backgroundColor: "#148840",
                        }}
                      >
                        <Stack
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          spacing={0}
                          my={0}
                        >
                          <Typography
                            sx={{
                              paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                              color: 'white',
                              fontFamily: 'Roboto',
                              textTransform: 'none',
                              fontSize: 16,
                            }}
                          >
                            <CreateNewFolderTwoToneIcon
                              fontSize="inherit"
                            >
                            </CreateNewFolderTwoToneIcon>
                            &nbsp;Crea evento&nbsp;
                          </Typography>
                        </Stack>
                      </Button>

                    </Stack>

                  </Box>

                </Paper>

              </Grid>

              {/* -----------------   FIN visualizza tutti gli eventi del giorno  ----------------- */}
             
              <Grid size={{ xs: 1, md: 0.1 }}>
              </Grid>


              {/* ---------------------------   INI inserimento info  --------------------------- */}

              <Grid size={{ xs: 12, md: 3.5 }}
                display={showInfoEventSection === 'Si' ? "block" : "none"}
                sx={{
                  paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                }}
              >

                <Paper
                  sx={{
                    paddingTop: 1, paddingBottom: 2, paddingLeft: 1, paddingRight: 1,
                    background: '#cce0e6',
                    color: 'navy',
                  }}
                  elevation={6}
                >

                  <Typography
                    sx={{
                      paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                      fontFamily: 'Roboto',
                      fontWeight: 300,
                      fontSize: 20,
                      color: 'yellow',
                      background: '#3970c9',
                      textAlign: 'center',
                    }}
                  >
                    {showDetailAppointmentNumber == -1 ? "crea" : "modifica"} evento di {bookingStartDateNameOfWeek} {strDateITAfromStrUSA(dayjs(bookingStartDate))}
                  </Typography>

            {/* 
                  <Typography
                    sx={{
                      paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                      fontFamily: 'Arial',
                      fontWeight: 300,
                      fontSize: 14,
                      color: 'navy',
                      textAlign: 'center'
                    }}
                  >
                    indexDB={indexStartDateBooking} showDetailAppointmentNumber={showDetailAppointmentNumber} prodottoScelto={prodottoScelto}
                  </Typography>
            */}

                  <Stack
                    direction="row"
                    spacing={1}
                    sx={{
                      paddingTop: 1, paddingBottom: 1, paddingLeft: 1, paddingRight: 1,
                    }}
                  >

                    <TextField id="id-oraini" label="ora inizio" variant="outlined" value={hourStartBookingString} defaultValue={hourStartBookingString}
                      sx={{
                        width: "10ch",
                        p: { xs: 1, md: 0 },
                        m: { xs: 1, md: 0 },
                      }}
                      onChange={(event) => {
                      }}
                    />

                    {!isManyDays &&

                      <FormControl
                        required
                        style={{
                          width: "25ch",
                        }}
                      >
                        <InputLabel id="sel-durata">Durata</InputLabel>
                        <Select
                          labelId="sel-durata"
                          id="id-sel-durata"
                          value={durataScelta}
                          label="Durata"
                          onChange={handleChangeDurata}
                          sx={{
                            width: "20ch",
                            p: { xs: 1, md: 0 },
                            m: { xs: 1, md: 0 },
                            marginRight: 1,
                          }}
                        >
                          {durationsMins.map(duration => {
                            return (
                              <MenuItem key={duration.message} value={duration.valueMins}>
                                {duration.message}
                              </MenuItem>
                            )
                          })}
                        </Select>
                      </FormControl>
                    }

                  </Stack>

                  <FormControl
                    sx={{
                      width: "40ch",
                      p: { xs: 1, md: 0 },
                      m: { xs: 1, md: 1 },
                    }}
                  >
                    <InputLabel id="style-select-label">
                      tipo evento
                    </InputLabel >
                    <Select
                      labelId="style-select-label"
                      id="style-select-label"
                      value={category}
                      label="tipo evento"
                      onChange={handleSelectEventType}
                    >

                      {eventTypesList.map((categoryItem, idx) => (
                        <MenuItem value={categoryItem.name}>{categoryItem.name}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl
                    sx={{
                      width: "40ch",
                      p: { xs: 1, md: 0 },
                      m: { xs: 1, md: 1 },
                    }}
                  >
                    <InputLabel
                      id="style-select-label-evento"
                    >
                      evento
                    </InputLabel >
                    <Select
                      labelId="style-select-label-evento"
                      id="style-select-label-evento"
                      value={prodottoScelto}
                      //defaultValue={prodottoScelto}
                      label="evento"
                      onChange={handleSelectEvent}
                    >

                      {eventsList.map((eventItem, idx) => (
                        <MenuItem value={eventItem.name}>{eventItem.name}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <TextField id="id-title" 
                    label="Titolo" 
                    variant="outlined"
                    value={titleAppointment}
                    sx={{
                      width: "40ch",
                      p: { xs: 1, md: 0 },
                      m: { xs: 1, md: 1 },
                    }}
                    onChange={(event) => {
                      setTitleAppointment(event.target.value);
                    }}
                  />

                  <TextField id="id-descriptionApp" 
                    label="Descrizione" 
                    variant="outlined"
                    value={descriptionAppointment}
                    sx={{
                      width: "40ch",
                      p: { xs: 1, md: 0 },
                      m: { xs: 1, md: 1 },
                    }}
                    onChange={(event) => {
                      setDescriptionAppointment(event.target.value);
                    }}
                  />

                  <TextField id="id-note" 
                    label="Note" 
                    variant="outlined"
                    value={noteAppointment}
                    sx={{
                      width: "40ch",
                      p: { xs: 1, md: 0 },
                      m: { xs: 1, md: 1 },
                    }}
                    onChange={(event) => {
                      setNoteAppointment(event.target.value);
                    }}
                    multiline
                    rows={3}
                    maxRows={6}
                  />

                  <Stack
                    direction="row"
                    spacing={1}
                    sx={{
                      paddingTop: 1, paddingBottom: 1, paddingLeft: 1, paddingRight: 1,
                    }}
                  >

                    {/* 
                    <TextField id="id-color" label="Colore" variant="outlined" type="color"
                      sx={{
                        width: "10ch",
                        p: { xs: 1, md: 0 },
                        m: { xs: 1, md: 0 },
                      }}
                      onChange={(event) => {
                        setColor(event.target.value);
                      }}
                    />
                   */}

                  </Stack>

                  <Box
                    component="form"
                    sx={{ '& > :not(style)': { m: 1, width: '40ch' } }}
                    noValidate
                    autoComplete="off"
                  >

                    <Autocomplete
                      disablePortal
                      options={optionCustomers}
                      renderInput={(params) => <TextField {...params} label="Cliente" />}
                      onChange={(event, value) => {
                        setClienteDigitato(value);
                      }}
                      defaultValue={cliente}
                      value={clienteDigitato}
                    />

                    <FormControl
                      style={{
                        width: "25ch",
                      }}
                    >
                      <InputLabel id="sel-risorsa">Risorsa</InputLabel>
                      <Select
                        labelId="sel-risorsa"
                        id="id-sel-risorsa"
                        value={risorsaScelta}
                        label="Risorsa"
                        onChange={handleChangeRisorsa}
                        defaultValue={risorsa}
                      >
                        {resources.map(resource => {
                          return (
                            <MenuItem key={resource.name} value={resource.name}>
                              {resource.name}
                            </MenuItem>
                          )
                        })}
                      </Select>
                    </FormControl>

                    <FormControl
                      style={{
                        width: "25ch",
                      }}
                    >
                      <InputLabel id="sel-sito">Sito</InputLabel>
                      <Select
                        labelId="sel-sito"
                        id="id-sel-sito"
                        value={sitoScelto}
                        label="Sito"
                        onChange={handleChangeSito}
                        defaultValue={sito}
                      >
                        {sites.map(site => {
                          return (
                            <MenuItem key={site.name} value={site.name}>
                              {site.name}
                            </MenuItem>
                          )
                        })}
                      </Select>
                    </FormControl>

                  </Box>

                  <Box
                    sx={{ '& > :not(style)': { m: 1, } }}
                  >

                    <Stack
                      direction="row"
                      justifyContent="flex-start"
                      alignItems="center"
                      spacing={1}
                      my={0}
                    >

                      <Button
                        type="button"
                        variant="contained"
                        color="warning"
                        //size="small"
                        onClick={(e) => {
                          handleAnnullaInserisciInfo();
                        }}
                        sx={{
                          width: "20ch",
                          borderRadius: 2,
                          //backgroundColor: "#8e9112",
                        }}
                      >
                        <Stack
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          spacing={0}
                          my={0}
                        >
                          <Typography
                            sx={{
                              paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                              color: 'white',
                              fontFamily: 'Roboto',
                              textTransform: 'none',
                              fontSize: 16,
                            }}
                          >
                            <CreateNewFolderTwoToneIcon
                              fontSize="inherit"
                            >
                            </CreateNewFolderTwoToneIcon>
                            &nbsp;Chiudi&nbsp;
                          </Typography>
                        </Stack>
                      </Button>

                      <Button
                        type="button"
                        variant="contained"
                        color="success"
                        //size="small"
                        onClick={(e) => {
                          handleSalvaAppuntamento();

                          // leggo db
                          getAppointmentsByDayApiRequest(getIndexOfDaysDb(dayjs(bookingStartDate.format('YYYY-MM-DD'))))
                            .then((data) => {
                              setAppointments(data?.appointments);
                              setDailyAppointments(data[0]?.appointments);
                              //setAppointments(data?.appointments);
                              console.log('[handleVediEventiGiorno] data=', data);
                              console.log('[handleVediEventiGiorno] data?.appointments=', data[0]?.appointments);
                              //console.log('appointment=', data?.appointment);
                              //console.log('appointments=', data?.appointments);
                              //setAppointment(data?.appointments[0]);
                              //console.log('appointment=', data?.appointment);

                            })
                          .catch((er) => {
                            console.log(er);
                          });

                          setShowDailyEventsSection("Si");
                        }}
                        sx={{
                          width: "20ch",
                          borderRadius: 2,
                          backgroundColor: "#148840",
                        }}
                      >
                        <Stack
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          spacing={0}
                          my={0}
                        >
                          <Typography
                            sx={{
                              paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                              color: 'white',
                              fontFamily: 'Roboto',
                              textTransform: 'none',
                              fontSize: 16,
                            }}
                          >
                            <CreateNewFolderTwoToneIcon
                              fontSize="inherit"
                            >
                            </CreateNewFolderTwoToneIcon>
                            &nbsp;Salva&nbsp;
                          </Typography>
                        </Stack>
                      </Button>

                    </Stack>

                  </Box>

                </Paper>

                <Box
                  sx={{
                    paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                    height: 40
                  }}
                />

              </Grid>

              {/* ---------------------------   FIN inserimento info  --------------------------- */}


              {/*   
              -----------------   visualizzazione info  -----------------

              <Grid size={{ xs: 12, md: 3.5 }}
                //display={showInfoEventSection === 'Si' ? "block" : "none"}
                display={showDetailAppointmentNumber > -1 ? "block" : "none"}
                sx={{
                  paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                }}
              >

                <Paper
                  sx={{
                    paddingTop: 1, paddingBottom: 2, paddingLeft: 1, paddingRight: 1,
                    background: '#cce0e6',
                    color: 'navy',
                  }}
                  elevation={6}
                >

                  <Typography
                    sx={{
                      paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                      fontFamily: 'Roboto',
                      fontWeight: 300,
                      fontSize: 20,
                      color: 'yellow',
                      background: '#3970c9',
                      textAlign: 'center',
                    }}
                  >
                    evento di {bookingStartDateNameOfWeek} {strDateITAfromStrUSA(dayjs(bookingStartDate))} show={showDetailAppointmentNumber}
                  </Typography>
                  <Typography
                    sx={{
                      paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                      fontFamily: 'Arial',
                      fontWeight: 300,
                      fontSize: 14,
                      color: 'navy',
                      textAlign: 'center'
                    }}
                  >
                    indexDB={indexStartDateBooking}
                  </Typography>

                  <Stack
                    direction="row"
                    spacing={1}
                    sx={{
                      paddingTop: 1, paddingBottom: 1, paddingLeft: 1, paddingRight: 1,
                    }}
                  >

                    <TextField id="id-oraini" label="ora inizio" variant="outlined" value={hourStartBookingString} defaultValue={hourStartBookingString}
                      sx={{
                        width: "10ch",
                        p: { xs: 1, md: 0 },
                        m: { xs: 1, md: 0 },
                      }}
                      onChange={(event) => {
                      }}
                    />

                    {!isManyDays &&

                      <FormControl
                        style={{
                          width: "25ch",
                        }}
                      >
                        <InputLabel id="sel-durata">Durata</InputLabel>
                        <Select
                          labelId="sel-durata"
                          id="id-sel-durata"
                          value={durataScelta}
                          label="Durata"
                          onChange={handleChangeDurata}
                          sx={{
                            width: "20ch",
                            p: { xs: 1, md: 0 },
                            m: { xs: 1, md: 0 },
                            marginRight: 1,
                          }}
                        >
                          {durationsMins.map(duration => {
                            return (
                              <MenuItem key={duration.message} value={duration.valueMins}>
                                {duration.message}
                              </MenuItem>
                            )
                          })}
                        </Select>
                      </FormControl>
                    }

                  </Stack>

                  <FormControl
                    sx={{
                      width: "40ch",
                      p: { xs: 1, md: 0 },
                      m: { xs: 1, md: 1 },
                    }}
                  >
                    <InputLabel id="style-select-label">
                      tipo evento
                    </InputLabel >
                    <Select
                      labelId="style-select-label"
                      id="style-select-label"
                      value={category}
                      label="tipo evento"
                      onChange={handleSelectEventType}
                    >

                      {eventTypesList.map((categoryItem, idx) => (
                        <MenuItem value={categoryItem.name}>{categoryItem.name}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl
                    sx={{
                      width: "40ch",
                      p: { xs: 1, md: 0 },
                      m: { xs: 1, md: 1 },
                    }}
                  >
                    <InputLabel
                      id="style-select-label"
                    >
                      evento
                    </InputLabel >
                    <Select
                      labelId="style-select-label"
                      id="style-select-label"
                      value={event}
                      label="evento"
                      onChange={handleSelectEvent}
                    >

                      {eventsList.map((eventItem, idx) => (
                        <MenuItem value={eventItem.name}>{eventItem.name}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <TextField id="id-titleApp" label="Titolo" variant="outlined"
                    sx={{
                      width: "40ch",
                      p: { xs: 1, md: 0 },
                      m: { xs: 1, md: 1 },
                    }}
                    onChange={(event) => {
                      setTitleAppointment(event.target.value);
                    }}
                  />

                  <TextField id="id-descriptionApp" label="Descrizione" variant="outlined"
                    sx={{
                      width: "40ch",
                      p: { xs: 1, md: 0 },
                      m: { xs: 1, md: 1 },
                    }}
                    onChange={(event) => {
                      setDescriptionAppointment(event.target.value);
                    }}
                  />

                  <TextField id="id-note" label="Note" variant="outlined"
                    sx={{
                      width: "40ch",
                      p: { xs: 1, md: 0 },
                      m: { xs: 1, md: 1 },
                    }}
                    onChange={(event) => {
                      setNoteAppointment(event.target.value);
                    }}
                    multiline
                    rows={3}
                    maxRows={6}
                  />

                  <Stack
                    direction="row"
                    spacing={1}
                    sx={{
                      paddingTop: 1, paddingBottom: 1, paddingLeft: 1, paddingRight: 1,
                    }}
                  >

                  </Stack>

                  <Box
                    component="form"
                    sx={{ '& > :not(style)': { m: 1, width: '40ch' } }}
                    noValidate
                    autoComplete="off"
                  >

                    <Autocomplete
                      disablePortal
                      options={optionCustomers}
                      renderInput={(params) => <TextField {...params} label="Cliente" />}
                      onChange={(event, value) => {
                        setClienteDigitato(value);
                      }}
                      defaultValue={cliente}
                    />

                    <FormControl
                      style={{
                        width: "25ch",
                      }}
                    >
                      <InputLabel id="sel-risorsa">Risorsa</InputLabel>
                      <Select
                        labelId="sel-risorsa"
                        id="id-sel-risorsa"
                        value={risorsaScelta}
                        label="Risorsa"
                        onChange={handleChangeRisorsa}
                        defaultValue={risorsa}
                      >
                        {resources.map(resource => {
                          return (
                            <MenuItem key={resource.name} value={resource.name}>
                              {resource.name}
                            </MenuItem>
                          )
                        })}
                      </Select>
                    </FormControl>

                    <FormControl
                      style={{
                        width: "25ch",
                      }}
                    >
                      <InputLabel id="sel-sito">Sito</InputLabel>
                      <Select
                        labelId="sel-sito"
                        id="id-sel-sito"
                        value={sitoScelto}
                        label="Sito"
                        onChange={handleChangeSito}
                        defaultValue={sito}
                      >
                        {sites.map(site => {
                          return (
                            <MenuItem key={site.name} value={site.name}>
                              {site.name}
                            </MenuItem>
                          )
                        })}
                      </Select>
                    </FormControl>

                  </Box>

                  <Box
                    sx={{ '& > :not(style)': { m: 1, } }}
                  >

                    <Stack
                      direction="row"
                      justifyContent="flex-start"
                      alignItems="center"
                      spacing={1}
                      my={0}
                    >

                      <Button
                        type="button"
                        variant="contained"
                        color="warning"
                        //size="small"
                        onClick={(e) => {
                          handleAnnullaInCreaAppuntamento();
                        }}
                        sx={{
                          width: "20ch",
                          borderRadius: 2,
                          //backgroundColor: "#8e9112",
                        }}
                      >
                        <Stack
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          spacing={0}
                          my={0}
                        >
                          <Typography
                            sx={{
                              paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                              color: 'white',
                              fontFamily: 'Roboto',
                              textTransform: 'none',
                              fontSize: 16,
                            }}
                          >
                            <CreateNewFolderTwoToneIcon
                              fontSize="inherit"
                            >
                            </CreateNewFolderTwoToneIcon>
                            &nbsp;Annulla&nbsp;
                          </Typography>
                        </Stack>
                      </Button>

                      <Button
                        type="button"
                        variant="contained"
                        color="success"
                        //size="small"
                        onClick={(e) => {
                          handleSalvaAppuntamento();
                        }}
                        sx={{
                          width: "20ch",
                          borderRadius: 2,
                          backgroundColor: "#148840",
                        }}
                      >
                        <Stack
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          spacing={0}
                          my={0}
                        >
                          <Typography
                            sx={{
                              paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                              color: 'white',
                              fontFamily: 'Roboto',
                              textTransform: 'none',
                              fontSize: 16,
                            }}
                          >
                            <CreateNewFolderTwoToneIcon
                              fontSize="inherit"
                            >
                            </CreateNewFolderTwoToneIcon>
                            &nbsp;Salva&nbsp;
                          </Typography>
                        </Stack>
                      </Button>

                    </Stack>

                  </Box>

                </Paper>

                <Box
                  sx={{
                    paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                    height: 40
                  }}
                />

              </Grid>

              */}


            </Grid>

            <Box
              sx={{
                paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                height: 40
              }}
            />

          </Grid>
        </Grid>

      </Box >

    </>

  );
};

export default AppointmentPageComponent;
